import React from 'react'
import { useDispatch, useSelector } from 'react-redux'

import type { RootState, AppDispatch } from './store'

export const useAppDispatch = useDispatch.withTypes<AppDispatch>()
export const useAppSelector = useSelector.withTypes<RootState>()

export const useTemporaryTooltip = (duration: number = 1000) => {
  const [show, setShow] = React.useState(false)
  const timeoutRef = React.useRef<NodeJS.Timeout | null>(null)

  const trigger = React.useCallback(() => {
    setShow(true)
    if (timeoutRef.current) clearTimeout(timeoutRef.current)
    timeoutRef.current = setTimeout(() => setShow(false), duration)
  }, [duration])

  React.useEffect(() => {
    return () => {
      if (timeoutRef.current) clearTimeout(timeoutRef.current)
    }
  }, [])

  return { show, trigger }
}
